import { useState, useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2, Save } from "lucide-react";
import { toast } from "sonner";

const DEFAULT_DEPARTMENTS = [
  "Geschäftsführung",
  "Verwaltung",
  "Produktion",
  "Montage",
  "Lager",
  "Vertrieb",
  "Kundenservice"
];

const DepartmentSettings = () => {
  const [departments, setDepartments] = useState<string[]>(() => {
    const stored = localStorage.getItem("departments");
    return stored ? JSON.parse(stored) : DEFAULT_DEPARTMENTS;
  });
  const [newDepartment, setNewDepartment] = useState("");

  const handleAddDepartment = () => {
    if (!newDepartment.trim()) {
      toast.error("Bitte geben Sie einen Abteilungsnamen ein");
      return;
    }
    if (departments.includes(newDepartment.trim())) {
      toast.error("Diese Abteilung existiert bereits");
      return;
    }
    setDepartments([...departments, newDepartment.trim()]);
    setNewDepartment("");
  };

  const handleDeleteDepartment = (index: number) => {
    setDepartments(departments.filter((_, i) => i !== index));
  };

  const handleUpdateDepartment = (index: number, value: string) => {
    const updated = [...departments];
    updated[index] = value;
    setDepartments(updated);
  };

  const handleSave = () => {
    localStorage.setItem("departments", JSON.stringify(departments));
    window.dispatchEvent(new Event('storage-sync'));
    toast.success("Abteilungen gespeichert");
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Abteilungen verwalten</CardTitle>
        <CardDescription>
          Definieren Sie die verfügbaren Abteilungen für Ihre Mitarbeiter
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          {departments.map((dept, index) => (
            <div key={index} className="flex items-center gap-2">
              <Input
                value={dept}
                onChange={(e) => handleUpdateDepartment(index, e.target.value)}
                className="flex-1"
              />
              <Button
                variant="ghost"
                size="icon"
                onClick={() => handleDeleteDepartment(index)}
                className="text-destructive hover:text-destructive"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Input
            value={newDepartment}
            onChange={(e) => setNewDepartment(e.target.value)}
            placeholder="Neue Abteilung hinzufügen..."
            onKeyDown={(e) => e.key === "Enter" && handleAddDepartment()}
          />
          <Button variant="outline" onClick={handleAddDepartment}>
            <Plus className="h-4 w-4 mr-1" />
            Hinzufügen
          </Button>
        </div>

        <Button onClick={handleSave} className="w-full">
          <Save className="h-4 w-4 mr-2" />
          Abteilungen speichern
        </Button>
      </CardContent>
    </Card>
  );
};

export default DepartmentSettings;
